import { fileExtensions } from './constant';
import { isClient } from '../utils';
import logger from '../logger';
var body;

if (isClient) {
  body = document.body; // eslint-disable-line
}
/**
 * @private
 * Returns base64 part if stream include file type along with it.
 * @param {string} stream
 */


export var getBase64String = function getBase64String(stream) {
  var streamData = stream.split(',')[1];
  return streamData || stream;
};
/**
 * @private
 * Returns base64 to ArrayBuffer.
 * @param {string} stream
 */

var base64ToArrayBuffer = function base64ToArrayBuffer(stream) {
  var binaryString = window.atob(stream);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);

  for (var i = 0; i < binaryLen; i += 1) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }

  return bytes;
};
/**
 * Convert base64 string to blob
 * @param {string} stream
 * @param {string} type
 */


export var convertBase64ToBlob = function convertBase64ToBlob(stream, type) {
  return isClient && new Blob([base64ToArrayBuffer(getBase64String(stream))], {
    type: type
  });
};

var getFileExtension = function getFileExtension(type) {
  var ext = fileExtensions.find(function (file) {
    return file.type === type;
  });
  return ext ? ext.extension : '.csv';
};
/**
 * Generate File from Blob or base64 string
 * @param {string | Blob} stream
 * @param {string} type
 * @param {string} fileName
 */


export var fileDownloader = function fileDownloader(stream, type, fileName) {
  if (!isClient) return isClient;

  try {
    var blobData;

    if (stream instanceof Blob) {
      blobData = stream;
    } else {
      blobData = convertBase64ToBlob(stream, type);
    }

    var fileExtension = getFileExtension(type);

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blobData, "".concat(fileName, ".").concat(fileExtension));
      return true;
    }

    var fileData = window.URL.createObjectURL(blobData);

    if (body) {
      var link = document.createElement('a');
      body.appendChild(link);
      link.href = fileData;
      link.download = "".concat(fileName, ".").concat(fileExtension);
      link.click();
      window.URL.revokeObjectURL(fileData);
      link.remove();
      return true;
    }

    return false;
  } catch (err) {
    logger.error('Error: ', err);
    return false;
  }
};
export { addFileExtension } from './constant';